import { Component, OnInit, Inject } from '@angular/core';
import { FunctionUtils } from '@sharedcommon/util/functions.util';
import { ResultColumnDto } from '@sharedcommon/model/result-column.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/**
 * Dialog component to show a list of equations which has a specific capped nutirent code
 */
@Component({
  styleUrls: [ './rawmaterial-blocked-results-popin.component.scss' ],
  templateUrl: './rawmaterial-blocked-results-popin.component.html'
})
export class NeqRawMaterialBlockedResultsPopinComponent implements OnInit {

  allBlockedResults: ResultColumnDto[] ;

  constructor(
    private readonly dialogRef: MatDialogRef<NeqRawMaterialBlockedResultsPopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      args: ResultColumnDto[],
      class: string
    }
  ) {
  }

  ngOnInit() {
    /* If execution error here that means that args is not well configured */
    this.allBlockedResults = this.data.args ;
  }

  getCalculatedValue(resultColumn: ResultColumnDto): any {
    const decimal: number = resultColumn.decimal ;
    const valueToShow: number = resultColumn.value ;
    return this.formatNumber(valueToShow, decimal) ;
  }

  getCeilValue(resultColumn: ResultColumnDto): any {
    return this.formatNumber(resultColumn.ceilVal, resultColumn.decimal) ;
  }

  getFloorValue(resultColumn: ResultColumnDto): any {
    return this.formatNumber(resultColumn.floorVal, resultColumn.decimal) ;
  }

  formatNumber(value: number, decimal: number): any {
    if (FunctionUtils.isDefined(value) && FunctionUtils.isDefined(decimal)) {
      return value.toFixed(decimal);
    } else if (FunctionUtils.isDefined(value)) {
      return value;
    } else {
      return '-' ;
    }
  }

   closeDialog() {
    this.dialogRef.close();
  }
}
